/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LogMessage } from './LogMessage';
import {
    LogMessageFromJSON,
    LogMessageFromJSONTyped,
    LogMessageToJSON,
} from './LogMessage';

/**
 * 
 * @export
 * @interface Log
 */
export interface Log {
    /**
     * The time the log was created.
     * @type {string}
     * @memberof Log
     */
    timestamp: string;
    /**
     * 
     * @type {LogMessage}
     * @memberof Log
     */
    message: LogMessage;
    /**
     * The severity of the log.
     * @type {string}
     * @memberof Log
     */
    severity: string;
}

/**
 * Check if a given object implements the Log interface.
 */
export function instanceOfLog(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "severity" in value;

    return isInstance;
}

export function LogFromJSON(json: any): Log {
    return LogFromJSONTyped(json, false);
}

export function LogFromJSONTyped(json: any, ignoreDiscriminator: boolean): Log {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'message': LogMessageFromJSON(json['message']),
        'severity': json['severity'],
    };
}

export function LogToJSON(value?: Log | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'message': LogMessageToJSON(value.message),
        'severity': value.severity,
    };
}

